import Joi from 'joi';
import {
  MEDIA_ASSET_IMAGE_MIME_TYPES,
  MEDIA_ASSET_VIDEO_MIME_TYPES,
  MEDIA_ASSET_SIZE_LIMIT_MB,
} from './config';

export const mediaAssetSchema = Joi.object({
  type: Joi.string()
    .valid(
      ...Object.keys({
        ...MEDIA_ASSET_IMAGE_MIME_TYPES,
        ...MEDIA_ASSET_VIDEO_MIME_TYPES,
      }),
    )
    .required()
    .messages({
      'any.only': 'File type is not supported',
    }),
  size: Joi.number()
    .max(MEDIA_ASSET_SIZE_LIMIT_MB * 1024 * 1024)
    .required()
    .messages({
      'number.max': 'File size is too large',
    }),
});
